<template>
  <div class="view-token text-center">
    <b-spinner variant="primary" />
  </div>
</template>

<script>
import { setTokens } from "@/setup/api";

export default {
  mounted() {
    const { token, refresh } = this.$route.query;
    setTokens(token, refresh);
    this.$store.commit("user/setLogged", true);
    setTimeout(() => {
      this.$router.replace({ name: "home" });
    }, 300);
  }
};
</script>
